// Chuyển qua lại giữa HTML của trình soạn thảo (TinyMCE) và chữ thường.

/** HTML → chữ thường: mỗi đoạn / <br> một dòng, giải mã &amp; &lt; &nbsp;… (dùng cho xuất Excel, xem trước, tìm kiếm) */
export function htmlToText(html: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html.replace(/<(br|\/p|\/div|\/li|\/h\d)[^>]*>/gi, '$&\n'), 'text/html');
  return (doc.body.textContent || '').replace(/ /g, ' ').replace(/\n{3,}/g, '\n\n').trim();
}

/**
 * Dữ liệu cũ nhập bằng ô chữ thường (không có thẻ HTML) → mỗi dòng một <p>, để trình soạn thảo
 * không gộp hết thành một dòng. Đã là HTML thì giữ nguyên.
 */
export function textToHtml(text: string): string {
  if (!text || /<\/?[a-z][^>]*>/i.test(text)) return text || '';
  const esc = (s: string) => s.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]!));
  return text.split(/\r?\n/).map(l => `<p>${esc(l) || '&nbsp;'}</p>`).join('');
}
